<template>
    <ContentOrLoading>
        <div v-if="!loading" class="row">
            <div class="alert alert-danger col-12 text-center" role="alert" v-if="gd_online == 0">
                AVISO: Los gastos de gestión están establecidos a 0
            </div>
            <div class="col-12">
                <FormInput label="Descripción" type="text" name="descripcion" id="texto" rules="required" v-model="entrada.descripcion" />
            </div>
            <div v-if="!butacas" class="col-12">
                <FormInput label="Zona" type="text" name="zona" id="zona" rules="required" v-model="entrada.zona" />
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="precio">Precio</label>
                    <ValidationProvider name="precio" rules="required" v-slot="{ errors }">
                        <input type="decimal" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="precio" placeholder="Precio" v-model="entrada.precio"/>
                        <small v-if="evento">Gastos de gestión no incluidos - (Online: {{ gd_online }}{{ entrada.moneda | formatear_moneda }} / {{ parseFloat(entrada.precio) + gd_online | formatear_precio }}) - (Taquilla: {{ gd_taquilla }}{{ entrada.moneda | formatear_moneda }} / {{ parseFloat(entrada.precio) + gd_taquilla | formatear_precio }}).</small>
                        <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="color">Color</label>
                    <input
                        type="color"
                        id="color"
                        class="form-control w-full"
                        v-model="entrada.color"
                    />
                </div>
            </div>
            <div class="col-12">
                <FormInput label="Información (Máx 150 carácteres)" maxlength="150" type="text" name="informacion" id="informacion" rules="" v-model="entrada.informacion" />
            </div>
            <div class="col-12" v-if="!recinto">
                <FormInput label="Stock" type="text" name="stock" id="precio" rules="required" v-model="entrada.units" />
            </div>
            <div class="col-12 col-lg-6" v-if="!recinto">
                <FormInput label="Número mínimo de entradas por pedido" type="text" name="Mínimo" id="n_entradas_min" rules="required" v-model="entrada.n_entradas_min" />
            </div>
            <div class="col-12 col-lg-6" v-if="!recinto">
                <FormInput label="Número máximo de entradas por pedido" type="text" name="Máximo" id="n_entradas_max" rules="required" v-model="entrada.n_entradas_max" />
            </div>
            <div class="col-12 col-lg-6">
                <div class="form-group">
                    <label for="fecha_inicio">Fecha de inicio de venta</label>
                    <ValidationProvider name="fecha_inicio" rules="required" v-slot="{ errors }" mode="passive">
                        <datetime 
                            v-model="entrada.sale_start_zulu"
                            :input-class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                            type="datetime"
                            input-id="fecha_inicio"
                            :min-datetime="new Date().toISOString()"
                            @input="clear"
                        />
                        <span 
                            v-if="errors[0]" 
                            id="exampleInputEmail1-error" 
                            class="error invalid-feedback"
                            style="display: block"
                        >
                            {{ errors[0] }}
                        </span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <div class="form-group">
                    <label for="fecha_fin">Fecha de fin de venta</label>
                    <ValidationProvider name="fecha_fin" rules="required" v-slot="{ errors }" mode="passive">
                        <datetime 
                            v-model="entrada.sale_stop_zulu"
                            :input-class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                            type="datetime"
                            input-id="fecha_fin"
                            :disabled="entrada.sale_start_zulu == ''"
                            :min-datetime="entrada.sale_start_zulu"
                            :max-datetime="evento.end_event_date"
                        />
                        <span 
                            v-if="errors[0]" 
                            id="exampleInputEmail1-error" 
                            class="error invalid-feedback"
                            style="display: block"
                        >
                            {{ errors[0] }}
                        </span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12" v-if="!recinto">
                <div class="form-group">
                    <label for="recinto">Tipo de entrada</label>
                    <select v-model="entrada.visible" id="tipo" name="tipo" class="form-control">
                        <option 
                            v-for="tipo in tipos"
                            :key="tipo.tipo"
                            :value="tipo.tipo"
                        >
                            {{ tipo.name }}
                        </option>
                    </select>
                </div>
                <MultiselectComponent
                    v-if="taquilleros.length > 0"
                    v-model="entrada.usuarios_ids"
                    label="Seleccionar taquilleros"
                    :options="taquilleros"
                    id="select-taquilleros"
                />
            </div>
            <div class="col-12">
                <div class="form-group">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="entrada.dia_abonado"/>
                        <label class="custom-control-label" for="customSwitch1">Entrada para abonados</label>
                    </div>
                </div>
            </div>
            <div v-if="entrada.dia_abonado" class="col-12">
                <div class="form-group">
                    <label for="abonos-dia-abonado" class="text-danger">Si no asignas ningún tipo de abono a esta entrada, se mostrarán todos en el proceso de compra</label>
                    <multiselect
                        id="abonos_dia_abonado"
                        v-model="entrada.precios_abonos"
                        placeholder="Tipos de abonos"
                        label="descripcion"
                        :custom-label="labelDescuentosAbonos"
                        track-by="id"
                        :options="evento.precios_abonos"
                        :multiple="true"
                        :max-height="200"
                        style="z-index: 999"
                    >
                        <template slot="option" slot-scope="item">
                            <strong>{{item.option.descripcion}}</strong> - ({{item.option.nombre_precio}}) <small>{{item.option.renovacion ? '*renovación' : ''}}</small>
                        </template>
                    </multiselect>
                </div>
            </div>
            <div class="col-12" v-if="manager.tipo == 2">
                <div class="form-group">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="customSwitch3" v-model="entrada.restar_abonos"/>
                        <label class="custom-control-label" for="customSwitch3">Al comprar abonos restar stock en esta entrada. (Solo activarlo en una entrada para cada sesión)</label>
                    </div>
                </div>
            </div>
    
            <div class="col-12">
                <div class="form-group">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="requiere_verificacion" v-model="entrada.requiere_verificacion"/>
                        <label class="custom-control-label" for="requiere_verificacion">Requiere Verificación</label>
                    </div>
                </div>
            </div>
    
            <div class="col-12">
                <div class="form-group">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="tiene_regalo" v-model="entrada.tiene_regalo"/>
                        <label class="custom-control-label" for="tiene_regalo">Incluye un regalo</label>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="edit_imagenes" v-model="editar_imagenes"/>
                        <label class="custom-control-label" for="edit_imagenes">Editar Imagenes entrada</label>
                    </div>
                </div>
            </div>
            <div class="col-12" v-if="editar_imagenes">
                <div v-if="entrada.imagen_cabecera_url">
                    <img :src="entrada.imagen_cabecera_url" style="max-height: 300px"/>
                    <br/>
                    <Button class="mt-2 mb-2" @click="imagenBorrada('imagen_cabecera')">Borrar</Button>
                </div>
                <div v-else class="form-group">
                    <label for="imagen">Imagen cabecera</label>
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        @success="imagenSubida('imagen_cabecera', ...arguments)"
                    />
                </div>
            </div>
            <div class="col-12" v-if="editar_imagenes">
                <div v-if="entrada.imagen_publicidad_url">
                    <img :src="entrada.imagen_publicidad_url" style="max-height: 300px"/>
                    <br/>
                    <Button class="mt-2 mb-2" @click="imagenBorrada('imagen_publicidad')">Borrar</Button>
                </div>
                <div v-else class="form-group">
                    <label for="imagen">Imagen publicidad</label>
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        @success="imagenSubida('imagen_publicidad', ...arguments)"
                    />
                </div>
            </div>
            <div class="col-12" v-if="editar_imagenes">
                <div v-if="entrada.imagen_patrocinadores_url">
                    <img :src="entrada.imagen_patrocinadores_url" style="max-height: 300px"/>
                    <br/>
                    <Button class="mt-2 mb-2" @click="imagenBorrada('imagen_patrocinadores')">Borrar</Button>
                </div>
                <div v-else class="form-group">
                    <label for="imagen">Imagen patrocinadores</label>
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        @success="imagenSubida('imagen_patrocinadores', ...arguments)"
                    />
                </div>
            </div>
        </div>
    </ContentOrLoading>
</template>

<script>
    import Dropzone from '@/components/common/Dropzone';
    import MultiselectComponent from '../../../common/forms/MultiselectComponent.vue';

    export default {
        props: ['entrada', 'sesion', 'recinto', 'evento_id', 'butacas'],
        data() {
            return {
                tipos: [
                    {
                        tipo: 0,
                        name: 'Física'
                    },
                    {
                        tipo: 1,
                        name: 'Online'
                    },
                    {
                        tipo: 2,
                        name: 'Genérica (Online + Física)'
                    }
                ],
                editar_imagenes: false,
                vouchers: [],
                evento: null,
                loading: false,
                url: this.config.API_BASE + '/upload/image?permisos=public&api_key=' + localStorage.getItem('token'),
                taquilleros: []
            }
        },
        created() {
            if(!this.entrada.sort){
                this.entrada.sort = 0;
            }
            this.setFechaInicio();
            this.setFechaFin();
            this.getEvento(this.evento_id);
            this.getTaquilleros();
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            gd_online() {
                var gd = null;
                if (this.entrada.dia_abonado) {
                    gd = this.$store.getters.getGd['venta_dia_abono_online'];
                } else {
                    gd = this.$store.getters.getGd['venta_entrada_online'];
                }

                if (this.evento && this.evento.experiencia){
                    gd = this.$store.getters.getGd['venta_experiencias_online'];
                }

                if(gd == undefined){
                    return 0;
                }

                if (gd['interno']) {
                    return 0;
                }

                var cantidad = gd['cantidad'];

                if (gd['modalidad']) {
                    cantidad = cantidad / 100;
                    cantidad = this.entrada.precio * cantidad;
                }

                cantidad = this.round(cantidad, 2);

                return cantidad;
            },
            gd_taquilla() {
                var gd = null;
                if (this.entrada.dia_abonado) {
                    gd = this.$store.getters.getGd['venta_dia_abono_online'];
                } else {
                    gd = this.$store.getters.getGd['venta_entrada_fisica'];
                }

                if (this.evento && this.evento.experiencia){
                    gd = this.$store.getters.getGd['venta_experiencias_fisica'];
                }

                if(gd == undefined){
                    return 0;
                }

                if (gd['interno']) {
                    return 0;
                }

                var cantidad = gd['cantidad'];

                if (gd['modalidad']) {
                    cantidad = cantidad / 100;
                    cantidad = this.entrada.precio * cantidad;
                }

                cantidad = this.round(cantidad, 2);

                return cantidad;
            },
        },
        methods: {
            labelDescuentosAbonos(precio) {
                if (precio) {
                    let optionPrice = precio;
                    return `${optionPrice.descripcion} - (${optionPrice.nombre_precio}) ${optionPrice.renovacion ? '*r' : ''}`
                }
            },
            setFechaInicio() {
                if (!this.entrada.sale_start) {
                    this.entrada.sale_start = moment(new Date()).toISOString();
                }
            },
            setFechaFin() {
                if (!this.entrada.sale_stop) {
                    this.entrada.sale_stop = this.sesion.fecha_zulu;
                }
            },
            round(num, decimales = 2) {
                var signo = (num >= 0 ? 1 : -1);
                num = num * signo;
                if (decimales === 0)
                    return signo * Math.round(num);
                num = num.toString().split('e');
                num = Math.round(+(num[0] + 'e' + (num[1] ? (+num[1] + decimales) : decimales)));
                num = num.toString().split('e');
                return signo * (num[0] + 'e' + (num[1] ? (+num[1] - decimales) : -decimales));
            },
            clear() {
                if (new Date(this.entrada.sale_start_zulu) > new Date(this.entrada.sale_stop_zulu)) {
                    this.entrada.sale_stop_zulu = '';
                }
            },
            getEvento(evento_id) {
                this.loading = true;
                const data = {
                    evento_id: evento_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.show-info-entradas'), data).then(res => {
                    this.evento = res.data.data;
                    if (this.entrada.imagen_cabecera_url || this.entrada.imagen_publicidad_url || this.entrada.imagen_patrocinadores_url) {
                        this.editar_imagenes = true;
                    }
                    this.loading = false;
                });
            },
            imagenBorrada(campo) {
                switch (campo) {
                    case 'imagen_cabecera':
                        this.entrada.imagen_cabecera = null;
                        this.entrada.imagen_cabecera_url = null;
                        break;
                    case 'imagen_publicidad':
                        this.entrada.imagen_publicidad = null;
                        this.entrada.imagen_publicidad_url = null;
                        break;
                    case 'imagen_patrocinadores':
                        this.entrada.imagen_patrocinadores = null;
                        this.entrada.imagen_patrocinadores_url = null;  
                        break;
                }
            },
            imagenSubida(campo, file, response) {
                switch (campo) {
                    case 'imagen_cabecera':
                        this.entrada.imagen_cabecera = response;
                        break;
                    case 'imagen_publicidad':
                        this.entrada.imagen_publicidad = response;
                        break;
                    case 'imagen_patrocinadores':
                        this.entrada.imagen_patrocinadores = response;
                        break;
                }
            },
            getTaquilleros() {
                const params = {
                    filters : {
                        select: true
                    }                
                };

                this.$store.dispatch(this.config.getVuexAlias('back.taquilleros.index'), params).then(res => {
                    this.taquilleros = res.data.data;
                });
            },
        },
        components: {
            Dropzone, MultiselectComponent
        }
    }
</script>
